import { render } from "./AddFiliereNiveauMatierePage.vue?vue&type=template&id=03e78a1f&ts=true"
import script from "./AddFiliereNiveauMatierePage.vue?vue&type=script&lang=ts"
export * from "./AddFiliereNiveauMatierePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__